import ptBR from './pt-BR'
import es from './es'
import us from './us'

// TODO: Adicionar outros dicionários
export default {
  'pt-BR': ptBR,
  es,
  us,
}
